module.exports = __webpack_public_path__ + "img/christmas-sale.3183903f.png";